/**
 * Tutorial guidato dell'elenco Offerte.
 *
 * Il piu' in alto porta dritto alla pagina della scheda. I tre pallini della riga
 * si raccontano illuminando il pulsante, non la voce dentro il menu: aprire un menu di Vuetify dal tutorial non e'
 * affidabile, perche' il click programmatico e quello su "Avanti" arrivano a
 * `document` a un soffio di distanza e il menu appena aperto legge il secondo come
 * un click fuori. Il pulsante invece c'e' sempre, e il testo dice cosa contiene.
 */
const SCOPE = '[data-tour-scope="offers"]';

const at = name => `${SCOPE} [data-tour="${name}"]`;

/** Nessun preparativo: niente da rimettere a posto a fine giro. */
export function stopOffersTour() {}

export function createOffersTourSteps() {
	return [
		{
			body: "Un'offerta abbassa il prezzo sul sito da sola, senza che il cliente debba scrivere niente: il prezzo scontato compare gia' nella scheda prodotto e nelle liste. E' la differenza con i coupon, che invece vanno digitati alla cassa.",
			key: 'intro',
			placement: 'bottom',
			target: at('tutorial'),
			title: 'Le offerte',
		},
		{
			body: "Il piu' in alto porta dritto alla pagina della nuova offerta: li' si sceglie quanto scontare, su cosa e per quanto tempo. Annulla riporta qui con l'elenco come l'avevi lasciato. La pagina ha un tutorial suo.",
			key: 'add',
			placement: 'left',
			target: at('add'),
			title: "Aggiungere un'offerta",
		},
		{
			body: "Ogni riga e' un'offerta: il nome, lo sconto gia' leggibile - meno dieci per cento, meno cinque euro - la durata, cioe' le date con lo stato (in corso, scaduta, non ancora iniziata) oppure le quantita' usate, e su cosa si applica.",
			key: 'table',
			placement: 'top',
			target: at('table'),
			title: 'Leggere l’elenco',
		},
		{
			body: "L'interruttore accende e spegne l'offerta, e salva subito. E' il comando piu' immediato che hai: un'offerta spenta smette di scontare all'istante, e i prezzi sul sito tornano quelli di listino.",
			key: 'switch',
			placement: 'right',
			target: at('switch'),
			title: "Accendere l'offerta",
		},
		{
			body: "Si applica a riassume su cosa cade lo sconto: quanti prodotti, brand e categorie, e se e' riservata ad alcuni clienti. Tutto il catalogo vuol dire che sconta ogni prodotto - va guardato due volte prima di accenderla.",
			key: 'references',
			placement: 'top',
			target: at('references'),
			title: 'Su cosa si applica',
		},
		{
			body: "Durata dice cosa tiene in vita l'offerta: le date, con accanto se e' in corso, scaduta o non ancora iniziata, oppure quante volte e' gia' stata usata su quante disponibili, con la barra che si riempie.",
			key: 'options',
			placement: 'top',
			target: at('options'),
			title: 'Le condizioni in breve',
		},
		{
			body: "I tre pallini a inizio riga aprono Modifica, che porta alla pagina dell'offerta, ed Elimina, che chiede conferma. Eliminare un'offerta non tocca gli ordini gia' fatti: quelli conservano il prezzo a cui sono stati chiusi.",
			key: 'row-menu',
			placement: 'right',
			target: at('row-menu'),
			title: 'Modificare o eliminare',
		},
		{
			body: "Il + apre l'offerta spiegata in una frase, un esempio di prezzo prima e dopo lo sconto e l'elenco completo di prodotti, brand, categorie e clienti.",
			key: 'expand',
			missing: 'skip',
			placement: 'right',
			target: at('expand'),
			title: "Come funziona l'offerta",
		},
		{
			body: "L'elenco arriva una pagina per volta dal server: da qui cambi pagina e quante righe vedere. Pagina, righe e ordinamento restano nell'indirizzo: ricaricando o tornando da una scheda li ritrovi.",
			key: 'pagination',
			placement: 'top',
			target: `${SCOPE} .v-data-footer`,
			timeout: 400,
			title: "Sfogliare l'elenco",
		},
	];
}
